var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('UploadPrimisReportCard'),_c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full mb-base"},[_c('PrimisBatch')],1)]),_c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full mb-base"},[_c('BrokerBatch')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }